export const CLEAR_FILTERS = '@@tickets/CLEAR_FILTERS';

export const GET_LIST = '@@tickets/GET_LIST';
export const GET_LIST_SUCCESS = '@@tickets/GET_LIST_SUCCESS';
export const GET_LIST_ERROR = '@@tickets/GET_LIST_ERROR';

export const GET_PAGINATION = '@@tickets/GET_PAGINATION';
export const GET_PAGINATION_SUCCESS = '@@tickets/GET_PAGINATION_SUCCESS';
export const GET_PAGINATION_ERROR = '@@tickets/GET_PAGINATION_ERROR';

export const GET_CONFIG = '@@tickets/GET_CONFIG';
export const GET_CONFIG_SUCCESS = '@@tickets/GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = '@@tickets/GET_CONFIG_ERROR';

export const GET_STATUSES_COUNTS = '@@tickets/GET_STATUSES_COUNTS';
export const GET_STATUSES_COUNTS_SUCCESS = '@@tickets/GET_STATUSES_COUNTS_SUCCESS';
export const GET_STATUSES_COUNTS_ERROR = '@@tickets/GET_STATUSES_COUNTS_ERROR';

export const GET_STAFF = '@@tickets/GET_STAFF';
export const GET_STAFF_SUCCESS = '@@tickets/GET_STAFF_SUCCESS';
export const GET_STAFF_ERROR = '@@tickets/GET_STAFF_ERROR';

export const ADD_TICKET = '@@tickets/ADD_TICKET';
export const ADD_TICKET_SUCCESS = '@@tickets/ADD_TICKET_SUCCESS';
export const ADD_TICKET_ERROR = '@@tickets/ADD_TICKET_ERROR';

export const GET_TICKET_VIEW = '@@tickets/GET_TICKET_VIEW';
export const GET_TICKET_VIEW_SUCCESS = '@@tickets/GET_TICKET_VIEW_SUCCESS';
export const GET_TICKET_VIEW_ERROR = '@@tickets/GET_TICKET_VIEW_ERROR';

export const SEND_MESSAGE = '@@tickets/SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = '@@tickets/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = '@@tickets/SEND_MESSAGE_ERROR';

export const UNREAD_MESSAGE = '@@tickets/UNREAD_MESSAGE';
export const UNREAD_MESSAGE_SUCCESS = '@@tickets/UNREAD_MESSAGE_SUCCESS';
export const UNREAD_MESSAGE_ERROR = '@@tickets/UNREAD_MESSAGE_ERROR';

export const CLOSE_TICKET = '@@tickets/CLOSE_TICKET';
export const CLOSE_TICKET_SUCCESS = '@@tickets/CLOSE_TICKET_SUCCESS';
export const CLOSE_TICKET_ERROR = '@@tickets/CLOSE_TICKET_ERROR';

export const MARK_AS_SPAM_TICKET = '@@tickets/MARK_AS_SPAM_TICKET';
export const MARK_AS_SPAM_TICKET_SUCCESS = '@@tickets/MARK_AS_SPAM_TICKET_SUCCESS';
export const MARK_AS_SPAM_TICKET_ERROR = '@@tickets/MARK_AS_SPAM_TICKET_ERROR';

export const DELETE_TICKET = '@@tickets/DELETE_TICKET';
export const DELETE_TICKET_SUCCESS = '@@tickets/DELETE_TICKET_SUCCESS';
export const DELETE_TICKET_ERROR = '@@tickets/DELETE_TICKET_ERROR';

export const DELETE_MESSAGE = '@@tickets/DELETE_MESSAGE';
export const DELETE_MESSAGE_SUCCESS = '@@tickets/DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_ERROR = '@@tickets/DELETE_MESSAGE_ERROR';

export const CHANGE_MASS_STATUS = '@@tickets/CHANGE_MASS_STATUS';
export const CHANGE_MASS_STATUS_SUCCESS = '@@tickets/CHANGE_MASS_STATUS_SUCCESS';
export const CHANGE_MASS_STATUS_ERROR = '@@tickets/CHANGE_MASS_STATUS_ERROR';

export const CHANGE_TICKET_MESSAGE = '@@tickets/CHANGE_TICKET_MESSAGE';
export const CHANGE_TICKET_MESSAGE_SUCCESS = '@@tickets/CHANGE_TICKET_MESSAGE_SUCCESS';
export const CHANGE_TICKET_MESSAGE_ERROR = '@@tickets/CHANGE_TICKET_MESSAGE_ERROR';

export const MASS_ASSIGN = '@@tickets/MASS_ASSIGN';
export const MASS_ASSIGN_SUCCESS = '@@tickets/MASS_ASSIGN_SUCCESS';
export const MASS_ASSIGN_ERROR = '@@tickets/MASS_ASSIGN_ERROR';

export const ASSIGN_TICKET = '@@tickets/ASSIGN_TICKET';
export const ASSIGN_TICKET_SUCCESS = '@@tickets/ASSIGN_TICKET_SUCCESS';
export const ASSIGN_TICKET_ERROR = '@@tickets/ASSIGN_TICKET_ERROR';

export const CLEAR_TICKET_VIEW = '@@tickets/CLEAR_TICKET_VIEW';

export const SET_ACTIVE_TICKET_FOR_TICKET_VIEW = '@@tickets/SET_ACTIVE_TICKET_FOR_TICKET_VIEW';
